<template>
  <div class="wrapper">
    <Sidebar />
    <div class="d-flex flex-column page-content bg-light">
      <Navbar />
      <router-view />
      <footer-component />
      <SessionExpiredAlert />
      <UserDesactivated />
      <Warnings />
      <v-overlay
        :value="isLoading"
        opacity="0.8"
        z-index="999"
        class="text-center"
      >
        <InsideLoader />
        <p class="mt-2 text-center">
          {{ $store.state.isLoadingMessage }}
        </p>
      </v-overlay>
      <notifications position="top center">
        <template
          slot="body"
          slot-scope="{ item, close }"
        >
          <v-alert
            class="mt-4"
            dense
            prominent
            :type="item.type"
            dismissible
            @click="close"
          >
            {{ item.text }}
          </v-alert>
        </template>
      </notifications>
      <script
        data-videohub="metadata" 
        type="application/json"
      >
        {{ session }}
      </script>
    </div>
  </div>
</template>
<script>

import Sidebar from '@/student/components/Sidebar'
import FooterComponent from '@/common/components/Footer.vue'
import Warnings from '@/common/components/Warnings.vue'
import InsideLoader from '@/common/InsideLoader'
import {mapGetters, mapState} from 'vuex'
import Navbar from "@/student/components/Navbar.vue";
import SessionExpiredAlert from "@/common/components/SessionExpiredAlert.vue";
import UserDesactivated from "@/common/components/UserDesactivated.vue";

export default {
  components: {
    Sidebar,
    FooterComponent,
    InsideLoader,
    Warnings,
    Navbar,
    SessionExpiredAlert,
    UserDesactivated,
  },
  computed: {
    session(){
      return JSON.stringify({ userId: this.authUser.id })
    },
    isLoading() {
      return (
        this.isLoadingCycles ||
        this.isLoadingChallenge ||
        this.isFinishingChallenge ||
        this.isLoadingTrails ||
        this.isLoadingCalendar ||
        this.isLoadingGlobal
      )
    },
    ...mapGetters(['authUser']),
    ...mapState({
      isLoadingCycles: (state) => state.cycle.isLoadingCycles,
      isLoadingChallenge: (state) => state.challenge.isLoadingChallenge,
      isFinishingChallenge: (state) => state.challenge.isFinishChallenge,
      isLoadingTrails: (state) => state.trail.isLoadingTrails,
      isLoadingCalendar: (state) => state.calendar.isLoadingCalendar,
      isLoadingGlobal: (state) => state.isLoading,
    }),

    ...mapGetters(['hasNotBlockWarnings'])
  },
}
</script>
